import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'
import { detectCountryAndSetLanguage } from './i18n'

// Detect country and set language based on geolocation
detectCountryAndSetLanguage();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Global smooth-scroll fallback for in-page anchors (works in dropdown portals and mobile)
if (!(window as any).__domusSmoothScrollAttached) {
  (window as any).__domusSmoothScrollAttached = true;
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;
    const anchor = target.closest('a[href^="#"]') as HTMLAnchorElement | null;
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (!href || href === '#') return;

    const id = decodeURIComponent(href.slice(1));
    const el = document.getElementById(id);
    if (el) {
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}
